import { InternalAdminRole } from 'constants/internal-admin-roles';

export const checkIsInternalAdmin = (userOrInvitation: { adminRole: InternalAdminRole; }) => {
  return [
    InternalAdminRole.MANUFACTURING_ADMIN,
    InternalAdminRole.SALES_ADMIN,
    InternalAdminRole.SUPER_ADMIN
  ].includes(userOrInvitation.adminRole);
};